import { HeadTitle, Button, Spacer, Card } from 'oui';
import {
  VisualBox,
  FloatingBox,
  ScrollXBox,
  FloatingBoxWrap,
} from '../../etc/LBox/LBox';
import complete from '../../../assets/images/feature/feature-complete.png';
import { useCardList } from '../../../application/hooks/useCardList';
import { useParams } from 'react-router-dom';
import useNav from '../../../application/hooks/useNav';
import { useRecoilValue } from 'recoil';
import { beaconSelector } from '../../../application/recoil/selector';
import useBeacon from '../../../application/hooks/useBeacon';
import { PAGE_NM, LANDING_TYPE } from '../../../application/types/types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const MtgResultComplete = () => {
  const { media } = useParams();
  const { navigate, navigateByLinkType } = useNav();
  const { cardList } = useCardList(media || '', true);
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_LOAN_REQ,
  });

  const location: any = useLocation();
  const callInfo = location.state;

  const [intervalId, setIntervalId] = useState<any>(0);
  const [leftSec, setLeftSec] = useState<number>(3);
  const [ctaName, setCtaName] = useState(
    callInfo?.link
      ? `${leftSec}초 후 금융사 페이지로 이동`
      : '다른 대출 상품보기',
  );

  useEffect(() => {
    beacon.sendViewPage();
    if (intervalId <= 0 && callInfo?.link) {
      const id = setInterval(() => {
        setLeftSec((prev) => {
          return prev - 1;
        });
      }, 1000);
      setIntervalId(id);
    }
  }, []);

  const moveToOutLink = () => {
    navigateByLinkType(LANDING_TYPE.out_link, callInfo?.link);
    clearInterval(intervalId);
    setIntervalId(0);
    setLeftSec(-1);
    setCtaName(`다른 대출 상품보기`);
  };

  useEffect(() => {
    if (!callInfo?.link) {
      return;
    }

    if (leftSec <= 0) {
      moveToOutLink();
    } else {
      setCtaName(`${leftSec}초 후 금융사 페이지로 이동`);
    }
  }, [leftSec]);

  const onClickCta = () => {
    if (intervalId <= 0) {
      navigate('/mtg/result', { replace: true });
    } else {
      moveToOutLink();
    }
  };

  return (
    <>
      <HeadTitle
        textTitle={'대출 신청이 잘 완료되었어요!'}
        subTitle={'아래에서 다른 상품들도 확인해보세요'}
      />
      <VisualBox>
        <img src={complete} alt={'apply-complete'} />
      </VisualBox>
      <Spacer size={'md'} />

      <ScrollXBox>
        {cardList.map((item: any, idx: number) => (
          <Card
            key={idx + item.secondaryText + item.primaryText}
            avatar={item.avatar}
            text={item.primaryText}
            subText={item.secondaryText}
            onClickCard={() => {
              cardList[idx].navigate();
            }}
          />
        ))}
      </ScrollXBox>

      <FloatingBoxWrap>
        <FloatingBox>
          <Button
            flexible={true}
            configuration={'contained'}
            children={ctaName}
            onClick={onClickCta}
          />
        </FloatingBox>
      </FloatingBoxWrap>
    </>
  );
};
